import AzureFilesUploader from '../../../../../components/AzureFilesUploader/AzureFilesUploader';
import ValidationFileChip from '../../../../CourseValidationInternalStudent/parts/ModalCreateValidation/ValidationFileChip';
import { SecureResponseFile } from '../../../../../components/AzureFilesUploader/types';
import { useCallback } from 'react';
import { useTexts } from '../../hooks/useTexts';

type Props = {
  complementaryFiles: any;
  files: any;
  fileIdsByRole: {
    teacherFilesIds: number[];
    adminFilesIds: number[];
  };
  setFileIdsByRole: Function;
};

export const FileInput = ({
  complementaryFiles,
  files,
  fileIdsByRole,
  setFileIdsByRole,
}: Props) => {
  const texts = useTexts();

  const handleAddFile = useCallback(
    (file: SecureResponseFile) => {
      const addFileToAdmin = (fileId: number) => {
        setFileIdsByRole({
          ...fileIdsByRole,
          adminFilesIds: [...fileIdsByRole.adminFilesIds, fileId],
        });
      };
      complementaryFiles.append(file);
      addFileToAdmin(file.id);
    },
    [complementaryFiles, fileIdsByRole, setFileIdsByRole],
  );

  const handleRemoveFile = useCallback(
    (index: number) => {
      const removeFileFromAdmin = (fileId: number) => {
        setFileIdsByRole({
          ...fileIdsByRole,
          adminFilesIds: fileIdsByRole.adminFilesIds.filter(
            (element) => element !== fileId,
          ),
        });
      };

      const removeFileFromTeacher = (fileId: number) => {
        setFileIdsByRole({
          ...fileIdsByRole,
          teacherFilesIds: fileIdsByRole.teacherFilesIds.filter(
            (element) => element !== fileId,
          ),
        });
      };
      const fileId = complementaryFiles.fields[index].id;
      complementaryFiles.remove(index);
      if (fileIdsByRole.adminFilesIds.includes(fileId)) {
        removeFileFromAdmin(fileId);
      }
      if (fileIdsByRole.teacherFilesIds.includes(fileId)) {
        removeFileFromTeacher(fileId);
      }
    },
    [complementaryFiles, fileIdsByRole, setFileIdsByRole],
  );

  const handleDownloadFile = useCallback((file: SecureResponseFile) => {
    if (!file?.url) {
      return;
    }
    window.open(file?.url, '_blank');
  }, []);

  return (
    <>
      <AzureFilesUploader
        label={texts.table.detail.uploadFIlesLabel}
        disabled={false}
        onUploaded={(next) => handleAddFile(next)}
      />
      {!!files?.length && (
        <div
          className="w-full mt-3 d-flex flex-wrap align-items-center justify-content-start"
          style={{ gap: 5 }}
        >
          {files?.map((file: any, i: number) => (
            <ValidationFileChip
              key={file.id.toString()}
              value={i}
              children={`${file.name}.${file.extension}`}
              onRemove={true ? handleRemoveFile : undefined}
              onDownload={() => handleDownloadFile(file)}
            />
          ))}
        </div>
      )}
    </>
  );
};
